var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVehicleArrowArrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 8L18.7 2.8C18.6 2.5 18.3 2.3 18 2.3H15.8V0.8C15.8 0.4 15.5 0 15 0H3V1.5H14.2V10.9C13.5 11.3 13 12 12.8 12.7H8.1C7.7 11.1 6 10.1 4.4 10.5C2.8 10.9 1.8 12.6 2.2 14.2C2.6 15.8 4.3 16.8 5.9 16.4C7 16.1 7.8 15.3 8.1 14.2H12.8C13.2 15.8 14.8 16.8 16.4 16.4C17.5 16.1 18.3 15.3 18.6 14.2H20.2C20.6 14.2 21 13.9 21 13.4V8.2C21 8.1 21 8 21 7.9L20.9 8ZM5.3 15C4.5 15 3.8 14.3 3.8 13.5C3.8 12.7 4.5 12 5.3 12C6.1 12 6.8 12.7 6.8 13.5C6.8 14.3 6.1 15 5.3 15ZM15.8 3.8H17.6L19.2 7.6H15.8V3.8ZM15.8 15C15 15 14.3 14.3 14.3 13.5C14.3 12.7 15 12 15.8 12C16.6 12 17.3 12.7 17.3 13.5C17.3 14.3 16.6 15 15.8 15ZM19.5 12.8H18.6C18.3 11.5 17.1 10.6 15.7 10.6V9.1H19.5V12.9V12.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 2.5L4.2 3.6L6.1 5.5H0V7H6.1L4.2 8.9L5.3 10L9 6.2L5.3 2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVehicleArrowArrive);
export default __webpack_public_path__ + "static/media/ic-vehicle-arrow-arrive.3f4f731cdbc33ce8a04afe4c19c9534d.svg";
export { ForwardRef as ReactComponent };